export default __webpack_public_path__ + "static/media/avatar_2.8ea8428a.png";